import { useLocation, useNavigate } from "react-router-dom";
import DragDrop from "../DragDrop/DragDrop";
import DiagramActivity from "../DiagramActivity/DiagramActivity";
import { useState, useEffect } from "react";
import ActivityContainer from "../ActivityContainer/ActivityContainer";
import Roleplay from "../Roleplay/Roleplay";
import Graphic from "../Graphic/Graphic";
import { useWorldData } from "../../context/WorldContext";
import { getUserProgress, setUserProgress } from "../../utils/userUtils";

const ActivityPage = () => {
  const location = useLocation();
  const { activityData, from } = location.state;
  const navigate = useNavigate();
  const { currentWorldOrder } = useWorldData();
  const worldOrder = currentWorldOrder;

  const [worldId, setWorldId] = useState(null);
  const [progressDialogue, setProgressDialogue] = useState(null);
  const handleActivityCompletion = async () => {
    try {
      const progress = getUserProgress();
      //get the world order and next dialogue id
      if (progress.lastWorld && progress.lastDialogue) {
        //setWorldOrder(worldProgress.order);
        setWorldId(progress.lastWorld); //need to get the world order by world id
        setProgressDialogue(progress.lastDialogue);
      }

      // Update progress for the activity

      const updatedActivityProgresses = progress.activityProgresses.map(
        (activity) => {
          if (activity.name === activityData.name) {
            return { ...activity, unlocked: true };
          }
          return activity;
        }
      );

      // Prepare updated progress data
      progress.activityProgresses = updatedActivityProgresses;
      setUserProgress(progress);
      if (from === "World") {
        // Navigate back to World with nextDialogueId from progress
        navigate("/world", {
          state: {
            worldOrder: worldOrder,
            progressDialogue: progress.lastDialogue,
          },
        });
      } else {
        navigate("/activities");
      }
    } catch (error) {
      console.error("Error updating progress:", error);
    }
  };

  // Switch case to render based on the type of activity
  switch (activityData.type) {
    case "roleplay":
      return (
        <ActivityContainer>
          <Roleplay
            activityData={activityData.content}
            onCompletion={handleActivityCompletion}
            name={activityData.displayName}
            description={activityData.description}
            instructions={activityData.instructions}
          />
        </ActivityContainer>
      );
    case "match":
      return (
        <ActivityContainer>
          <DragDrop
            activityData={activityData.content}
            onCompletion={handleActivityCompletion}
            name={activityData.displayName}
            description={activityData.description}
            instructions={activityData.instructions}
          />
        </ActivityContainer>
      );
    case "graphic":
      return (
        <ActivityContainer>
          <Graphic
            activityData={activityData.content}
            onCompletion={handleActivityCompletion}
            name={activityData.displayName}
            description={activityData.description}
          />
        </ActivityContainer>
      );
    case "interactiveDiagram":
      return (
        <ActivityContainer>
          <DiagramActivity
            activityData={activityData.content}
            onCompletion={handleActivityCompletion}
            name={activityData.displayName}
            description={activityData.description}
            instructions={activityData.instructions}
          />
        </ActivityContainer>
      );
    default:
      return <p>No activity found</p>;
  }
};

export default ActivityPage;
